import { appStore, useAppSelector } from '@/store'
import type { Access, Product } from '@/store/app'
import { useLocation } from 'react-router-dom'

export const useRole = (product?: Product, accessRequest?: Access[]) => {
  const { employee, menuAccess, userRoles } = useAppSelector(appStore)
  // const role = employee?.roles[0]?.role.name
  const menu = employee?.roles[0]?.role.PermissionFrontOnRole[0]?.conf
  const location = useLocation()

  const hasRole = (value: string | string[]) => {
    const roles = [...(Array.isArray(value) ? [...value] : [value])]
    return roles.some((role) => userRoles?.includes(role))
  }

  const getAccess = (product?: Product, accessRequest?: Access[]) => {
    if (accessRequest) {
      return accessRequest.every(
        (e) =>
          menuAccess
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ?.find((e: any) => location.pathname.includes(e.pathname))
            .access.includes(e)
      )
    }
  }

  const access = getAccess(product, accessRequest) ?? false

  return {
    access,
    hasRole,
    menu,
    getAccess,
    employee,
  }
}
